export default {
	"forepartner": {
		"addPartner": "t添加伙伴",
		"forepartner": "t添加成功"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/forepartner/forepartner.js